import React from 'react';
import i18n from 'i18next';
import { connect } from 'react-redux';
import { Collapse, Modal, message } from 'antd';
import { InfoOutlined } from '@ant-design/icons'
import { LoadingComponent } from '../../utils/ui'
import { SkosScheme } from '../../redux';
import { subsetByLang, subsetByLangOrEmpty } from '../../virtuoso/helper';
import { ConceptSingle, ConceptPanel } from '../../components/skos/ConceptSmall';

const Panel = Collapse.Panel;
const { confirm } = Modal;

function callback(key) {
  console.log(key);
}

/** Сортирует концепты по вложенности. Идёт концепт без вложенности, затем все вложенные в него и т.д 
 * получаем концепты с наименованиями, уровнем, с флагом наличия вложения. */
function contentToConcepts(content,lang){
  const concepts = subsetByLangOrEmpty(content.concepts, lang, "IRI", "Label")
  concepts.forEach(concept => {
    concept["level"] = 0;
    concept["hasBroader"] = false;
    concept["children"] = [];
    concept["statistic"] = 0;
  } );
  let temp = concepts.reduce((result, item) => {
      result[item.IRI.value] = item;
      return result;
  }, {});
  //Сделаем сортировку по значению идентификатора
  if (content.identifier){
    concepts.forEach((concept, index) => {
      concept["identifier"] = concept.IRI.value? content.identifier[concept.IRI.value]: index;
    })
    concepts.sort((a,b) => {
        return a.identifier - b.identifier;
      });
  };
  //Сделаем связь и уровень по значению broader
  if (content.broader){
    //Будем бегать в цикле, пока произодит изменения индекса уровня
    let hasLevelChanged = true; let countIndex = 0;
    while (hasLevelChanged){
      hasLevelChanged = false;
      concepts.forEach(concept => {
        //Должно быть отличие соседних уровней на 1.
        if (content.broader[concept.IRI.value]){
          concept["broader"] = content.broader[concept.IRI.value];
          temp[concept["broader"]].hasBroader = true;
          if (!temp[concept["broader"]].children.includes(concept))
            temp[concept["broader"]].children.push(concept);
          if (temp[concept.IRI.value].level != temp[concept["broader"]].level+1){
            hasLevelChanged = true;
            temp[concept.IRI.value].level = temp[concept["broader"]].level+1;
          }
        }
      })
        countIndex++;
      if (countIndex>1000) {
        console.warn("ConceptScheme.js too long while level changed!!! countIndex is ", countIndex);
        break;
      }
    }
  };
  //console.log("ConceptScheme.js function contentToConcepts(content,lang) 2", concepts, lang)
  return concepts;
}

/** Формирует список концептов для отображения (с учётом иерархии концептов).
 * Если вложеный концепт отображется, то должна отображаться вся цепочка до уровня 0
 * 
 * Если hasCollapsed = true, то нужно создать список элементов, которые должны сворачиваться. Для этого дочерние элементы 
 * добавляеются в свойство children
*/
function conceptsForShow(concepts, loading, statistics, hasCollapsed=false){
  //Флаг пустой или нулевой статистики - для показа всего списка концептов
  const emptyStatistics = loading || Object.keys(statistics).length ==0 || Object.keys(statistics).filter(key =>
    statistics[key] == 0
    ).length == Object.keys(statistics).length;  
  if (emptyStatistics) 
    return hasCollapsed? makeCollapseTree(concepts): concepts;
  const filteredConcepts = concepts.filter(
      concept => hasChildrenStatistics(concept, statistics, (concept.children)?concept.children.length>0:false, concepts)
    );
    return hasCollapsed? makeCollapseTree(filteredConcepts): filteredConcepts;
}
/**Проверяет наличие статистики во вложенных элементах */
function hasChildrenStatistics(concept, statistics, checkChildrenStatistic, concepts){
  return true;
  // return !statistics.hasOwnProperty(concept.IRI.value) 
  //   || (statistics.hasOwnProperty(concept.IRI.value) && statistics[concept.IRI.value]!=0) 
  //   || (checkChildrenStatistic && concept.children.filter(
  //       child => hasChildrenStatistics(child, statistics, (child.children)?child.children.length>0: false, concepts)).length>0
  //     );
}

/** Формирует дерево из элементов, которые должны сворачиваться. В качестве основе используется сначение children в списке */
function makeCollapseTree (concepts) {
  let temp = concepts.reduce((result, item) => {
      result[item.IRI.value] = item;
      return result;
  }, {});
  return concepts.map(
      concept => Object.assign({...concept}, {"collapse": concept.children.filter(chid => temp[chid.IRI.value])})
    ).filter(
      concept => concept.level == 0
    );
}

const CollapseGroup = (view, root, concepts, selected, hasCheck, doOperation= f=>f, expand, hideStatistics=false, 
  operation=undefined, highlight=[]) => {
  const isRootChecked = hasChecked(view, root, selected, hasCheck);
  return (
    <Collapse defaultActiveKey={expand?['1']:[]} onChange={callback}>
      <Panel key="1" header={
        <ConceptPanel concept={root} hideStatistics={hideStatistics} operation={operation} 
        handlers={(e, concept, operation) => doOperation(e, concept, operation)} highlight={highlight}/>
      }>
        {concepts.map((concept, i)=> {
            const isChecked = hasChecked(view, concept, selected, hasCheck);
            return (
              <p key={i}>
                { (Array.isArray(concept.children) && concept.children.length>0) ?
                  CollapseGroup (view, concept, concept.children, selected, hasCheck, doOperation, expand, 
                    hideStatistics, operation, highlight) 
                : 
                <ConceptSingle concept={concept} hideStatistics={hideStatistics} operation={operation} 
                  handlers={(e, concept, operation) => doOperation(e, concept, operation)} highlight={highlight}/>
                }
              </p>
            )
          })
        }
      </Panel>
    </Collapse>
  )
}

/**
 * Проверка на установку галки в чекбоксе
 */
const hasChecked = (view, concept, selected, hasCheck=undefined) =>{
  //console.log("ConceptScheme.js hasChecked", view, concept, selected, hasCheck);
  if (view =='single' && hasCheck){
    return hasCheck.filter(item => item.iri ==concept.IRI.value).length>0;
  }
  return (selected)? selected.filter(
    item => (Array.isArray(item.value)?item.value.indexOf(concept.IRI.value)>=0:item.value==concept.IRI.value)
  ).length>0: false;  
}
/** Отображение схемы концептов (ConceptScheme в SKOS). Схема концептов определяется по IRI. 
 * 
 * Виды отображения (view) могут иметь следующие значения
 * 1. null или undefined - используется для задания условий отбора
 * 2. single - выбор одного значения (у остальных галки сбрасываются)
 * 
 * Для схемы:
 * 1. загружается имя схемы
 * 2. загружается состав концептов (концепты, которые имеют свойство http://www.w3.org/2004/02/skos/core#inScheme)
 * 3. загружается количество концептов 
 *    если флаг установле hideStatistics, статистика не загружается и не показывается
 * 
*/
class ConceptsInScheme extends React.Component {	
  state = {
    loading: true, 			//Флаг загрузки
    statistics:{},      //Статистика по количеству связанных концептов. Заполняется в результате выполнения 
  }

  componentWillMount() { 
    this.loadTaxonomy();
  }

  componentWillReceiveProps(nextProps){
    const {content} = nextProps;
    if ((content==undefined)||(content.state==undefined)||content.state=="empty")
      this.loadTaxonomy();
  }

  loadTaxonomy() {
    this.setState({loading: true});
    const {IRI} = this.props;
    if (IRI)
      this.props.dispatch(SkosScheme.loadTaxonomy(IRI))
      .then ((response) =>{
        this.setState({loading: false})
        if (!this.props.hideStatistics)
          this.loadTaxonomyStatistics();
			})
			.catch(e => { 
        this.setState({loading: false})
			});
  }
   
  /** Разлиные операции над концептом */
  doOperation(e, concept, operation) {
    //console.log("InSchemeCard.js doOperation", concept, operation);
    const {handlers} = this.props;
    //handlers - handlers(e, triplet, operation) в ConceptSchemeCard
    if (operation=="detail" && handlers ){
      handlers(e, concept, "inScheme");
      return;
    };
    if (operation=="unlink" && handlers ){
      handlers(e, concept, "unlink");
      return;
    };
    if (operation=="edit" && handlers ){
      handlers(e, concept, "editConcept");
      return;
    };
    if (operation=="used" && handlers ){
      handlers(e, concept, "used");
      return;
    };
    if (operation=="replacement" && handlers ){
      handlers(e, concept, "replacement");
      return;
    };
    if (operation=="delete" && handlers ){
      if (concept.children.length>0){
        message.warning(i18n.t('views.skos.inSchemeCard.hasNarrowerConcepts', { count: concept.children.length }));
        return;
      }
      const deleteContent = (concept.statistic>0)? 
        i18n.t('views.skos.inSchemeCard.deleteUsedConcept', { name: concept.Label.value })
      : i18n.t('views.skos.inSchemeCard.deleteConcept', { name: concept.Label.value });
      confirm({ title: i18n.t('views.skos.common.deleteSelected'), content: deleteContent,
        okText: i18n.t('views.skos.common.yes'), okType: 'danger', cancelText: i18n.t('views.skos.common.no'),
        onOk() { 
          handlers(e, concept, "deleteConcept");
        },
        onCancel() {},
      });      
      return;
    };
  };

  loadTaxonomyStatistics() {
    //console.log("ConceptScheme.js loadTaxonomyStatistics()", this);
    const {loading } = this.state
    const {content, lang,graph, rfilter} = this.props;
    const concepts = (!loading && content && content.concepts)? subsetByLangOrEmpty(content.concepts, lang, "IRI", "Label"):[];
    const requests = concepts.map(concept =>
      this.props.dispatch(SkosScheme.loadTaxonomyConceptCount(concept.IRI.value, lang, graph, rfilter))
    )
    Promise.all(requests)
      .then(result => {
        const statistics = {}
        result.forEach(item => statistics[item.conceptIRI] = item.count)
        // //Для тестирования
        // statistics['http://purl.semanticpro.org/section/IndustrialOutputAtCurrentAndConstantPrices'] = 2;
        this.setState({statistics: statistics})
      })
  }
  onChangeConcept(e, concept, children = undefined) {
    e.preventDefault();
    const {handlers} = this.props;
    //console.log("InSchemeCard.js onChangeConcept", concept, children, this);
    if (handlers){
      handlers(e, concept, "inScheme");
      return;
    };    
  }

  render() {
    const {loading, statistics} = this.state
    //expand = флаг - открыть всё по-умолчанию
    const {IRI, content, lang, selected, expand, hideStatistics, view, hasCheck, operation, highlight} = this.props;
    const hasConcepts = !loading && content && content.concepts;
    const allConcepts = hasConcepts ? contentToConcepts(content, lang):[];
    const header = i18n.t('skos.scheme.inScheme');
    //Если есть связь skos:broader то использовать свёртывание уровней
    const hasBroader = (hasConcepts && content.broader)? Object.keys(content.broader).length>0:false;
    const concepts = conceptsForShow(allConcepts, loading, statistics, true);
    console.log(this, concepts); //console.log(loading); console.log(JSON.stringify(content));
    //Формируем отображение название схемы и список элементов в схеме
    return (
      <Collapse defaultActiveKey={expand?['1']:[]} onChange={callback} style={{"width":"100%"}}>
        <Panel header={header} key="1" onClick={(e) => e.stopPropagation()}>
            {loading && <LoadingComponent />}
            {concepts.map((concept, i)=> {
                const isChecked = hasChecked(view, concept, selected, hasCheck);
                return (
                  <p key={i}>
                    { 
                    (Array.isArray(concept.children) && concept.children.length>0) ?
                      CollapseGroup (view, concept, concept.children, selected, hasCheck, 
                        (e, concept, operation) => this.doOperation(e, concept, operation), 
                        expand, hideStatistics, operation, highlight)
                    : 
                    <ConceptSingle concept={concept} hideStatistics={hideStatistics} operation={operation} 
                      handlers={(e, concept, operation) => this.doOperation(e, concept, operation)} highlight={highlight}/>
                    }
                  </p>
                )
              })
            }
            {(!loading && (concepts.length==0)) && <p>{i18n.t('views.skos.inSchemeCard.noRelatedConcepts')}</p>}
        </Panel>
      </Collapse>
    )
  }
}

function mapStateToProps(state, props) {
  //Значения в store redux
  const {vadms, scheme, vset} = state;
  const {lang, graph} = props;
  const content = (scheme.taxonomy)? scheme.taxonomy.filter(item => item.IRI.value==props.scheme):[];
  return {
      lang: (lang)?lang: vset.lang,
      graph: (graph)?graph: vset.graph,
      IRI: props.scheme,
      content: (Array.isArray(content)&& content.length>0)? content[0]: undefined,
      rfilter: vadms.rfilter,
      selected: vadms.conditions,
  };
}

export default connect(mapStateToProps)(ConceptsInScheme);
